module.exports = __webpack_public_path__ + "static/media/Coffee.57345bb8.png";